import React, { useState, useEffect } from 'react';
import { Container, Switch, Button, Title, Loader } from '@bsf/force-ui';
import { __ } from '@wordpress/i18n';
import apiFetch from '@wordpress/api-fetch';
import { Toaster, toast } from 'react-hot-toast';

const Debug = () => {
    const [loading, setLoading] = useState(true);
    const [settings, setSettings] = useState({
        video_fixer: false,
        ajax_theme: false,
        theme_support: false,
        rtl_support: false,
        custom_vc_row: '',
        dev_mode: false,
        global_scripts: false,
        modal_menu: false,
        smooth_scroll_compatible: false,
        animation_block: false,
        roles: [],
    });
    const [rolesList, setRolesList] = useState([]);
    const [showAdvanced, setShowAdvanced] = useState(() => {
        try {
            return localStorage.getItem('uavcShowAdvanced') === 'true';
        } catch (e) {
            return false;
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem('uavcShowAdvanced', showAdvanced.toString());
        } catch (e) {
            // Fail silently if storage is unavailable
        }
    }, [showAdvanced]);

    useEffect(() => {
        apiFetch({ path: '/ultimate-vc/v1/debug-options' })
            .then((response) => {
                if (response) {
                    setSettings({
                        video_fixer: response.video_fixer === 'enable',
                        ajax_theme: response.ajax_theme === 'enable',
                        theme_support: response.theme_support === 'enable',
                        rtl_support: response.rtl_support === 'enable',
                        custom_vc_row: response.custom_vc_row || '',
                        dev_mode: response.dev_mode === 'enable',
                        global_scripts: response.global_scripts === 'enable',
                        modal_menu: response.modal_menu === 'enable',
                        smooth_scroll_compatible: response.smooth_scroll_compatible === 'enable',
                        animation_block: response.animation_block === 'enable',
                        roles: Array.isArray(response.roles) ? response.roles : [],
                    });
                    setRolesList(response.all_roles || []);
                }
            })
            .catch((error) => {
                console.error('Error fetching debug options:', error);
            })
            .finally(() => setLoading(false));
    }, []);

    const toggle = (key) => {
        setSettings((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const handleRoleChange = (role) => {
        setSettings((prev) => {
            const roles = prev.roles.includes(role)
                ? prev.roles.filter((r) => r !== role)
                : [...prev.roles, role];
            return { ...prev, roles };
        });
    };

    const handleSave = () => {
        setLoading(true);
        const data = {
            video_fixer: settings.video_fixer ? 'enable' : 'disable',
            ajax_theme: settings.ajax_theme ? 'enable' : 'disable',
            theme_support: settings.theme_support ? 'enable' : 'disable',
            rtl_support: settings.rtl_support ? 'enable' : 'disable',
            custom_vc_row: settings.custom_vc_row,
            dev_mode: settings.dev_mode ? 'enable' : 'disable',
            global_scripts: settings.global_scripts ? 'enable' : 'disable',
            modal_menu: settings.modal_menu ? 'enable' : 'disable',
            smooth_scroll_compatible: settings.smooth_scroll_compatible ? 'enable' : 'disable',
            animation_block: settings.animation_block ? 'enable' : 'disable',
            roles: settings.roles,
        };

        apiFetch({
            path: '/ultimate-vc/v1/debug-options',
            method: 'POST',
            data,
        })
            .then(() => {
                toast.success(__('Settings updated successfully!', 'ultimate_vc'));
            })
            .catch((error) => {
                console.error('Error saving debug options:', error);
                toast.error(__('Failed to save settings', 'ultimate_vc'));
            })
            .finally(() => setLoading(false));
    };

    if (loading) {
(
    <Loader variant='primary' size='lg' className='flex items-center justify-center'/>
);
    }

    const renderToggleRow = (label, value, onChange, description) => (
    <div className="w-full">
        <Container
            align="center"
            className="flex flex-col lg:flex-row"
            containerType="flex"
            direction="column"
            gap="sm"
            justify="between"
            item
        >
            <Container.Item className="shrink flex flex-col space-y-1">
                <div className="text-base font-semibold m-0 mb-1">{label}</div>
                {description && (
                    <p style={{ color: '#9CA3AF' }} className="text-sm">
                        {description}
                    </p>
                )}
            </Container.Item>
            <Container.Item
                className="shrink-0 flex space-y-6 uavc-remove-ring"
                alignSelf="auto"
                order="none"
            >
                <Switch size="md" value={value} onChange={onChange} />
            </Container.Item>
        </Container>

        {/* Add a full-width <hr> after the row */}
        <hr
            className="w-full border-b-0 border-x-0 border-t border-solid border-t-border-subtle"
            style={{
                marginTop: '34px',
                marginBottom: '34px',
                borderColor: '#E5E7EB',
            }}
        />
    </div>
);


    return (
        <>
            <Toaster
                position="top-right"
                reverseOrder={false}
                gutter={8}
                containerStyle={{
                    top: 20,
                    right: 20,
                    marginTop: '40px',
                }}
                toastOptions={{
                    duration: 1000,
                    style: {
                        color: '#0017E1',
                    },
                    success: {
                        duration: 2000,
                        style: {
                            color: '',
                        },
                        iconTheme: {
                            primary: '#0017E1',
                            secondary: '#fff',
                        },
                    },
                }}
            />
             <style>
                {`
                    .role-checkbox {
                        position: relative;
                        width: 30px;
                        height: 30px;
                        -webkit-appearance: none;
                        appearance: none;
                        border: 2px solid #d1d5db; /* gray-300 */
                        border-radius: 4px;
                        cursor: pointer;
                    }

                    .role-checkbox:checked {
                        background-color: #0017E1;
                        border-color: #0017E1;
                    }

                    .role-checkbox:checked::after {
                        content: '';
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        width: 4px;
                        height: 8px;
                        border-right: 2px solid #fff;
                        border-bottom: 2px solid #fff;
                        transform: translate(-50%, -60%) rotate(45deg);
                    }
                `}
            </style>
            <div className="box-border bg-background-primary p-6 rounded-lg" style={{ marginTop: '24px' }}>
                <div className="relative">
                    <Container
                        align="center"
                        className="flex flex-col lg:flex-row"
                        containerType="flex"
                        direction="column"
                        gap="sm"
                        justify="between"
                        item
                    >
                        <Container.Item className="shrink flex flex-col space-y-1">
                            <div className="text-base font-semibold m-0 mb-1">
                                {__('Advanced Settings', 'ultimate_vc')}
                            </div>
                            <p style = {{ color: "#9CA3AF"}} className="text-sm">
                                {__('Control and manage debug features for Ultimate VC', 'ultimate_vc')}
                            </p>
                        </Container.Item>
                        <Container.Item
                            className="shrink-0 p-2 flex space-y-6 uavc-remove-ring"
                            alignSelf="flex-start"
                            order="none"
                            style={{ position: 'absolute', right: '0', top: '0' }}
                        >
                            <Switch
                                size="md"
                                value={showAdvanced}
                                onChange={() => setShowAdvanced(!showAdvanced)}
                            />
                        </Container.Item>
                    </Container>
                </div>
            </div>

            {showAdvanced && (
            <div className="box-border bg-background-primary p-6 rounded-lg" style={{ marginTop: '24px' }}>
                <div className="space-y-8">
                    {renderToggleRow(__('Video Fixer', 'ultimate_vc'), settings.video_fixer, () => toggle('video_fixer'),
                        __('Ensures compatibility for embedded videos by correcting common shortcode issues.', 'ultimate_vc'))}

                    {renderToggleRow(__('Ajax', 'ultimate_vc'), settings.ajax_theme, () => toggle('ajax_theme'),
                        __('Enables AJAX loading for dynamic content without full page reloads.', 'ultimate_vc'))}

                    {renderToggleRow(__('Theme Support', 'ultimate_vc'), settings.theme_support, () => toggle('theme_support'),
                        __('Enables enhanced support for compatible themes.', 'ultimate_vc'))}

                    {renderToggleRow(__('RTL Support', 'ultimate_vc'), settings.rtl_support, () => toggle('rtl_support'),
                        __('Adds support for right-to-left languages like Arabic or Hebrew.', 'ultimate_vc'))}

                    {!settings.theme_support && (
                        <div className="flex flex-col gap-1">
                            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center w-full">
                                <div className="mb-2 lg:mb-0">
                                    <div className="text-base font-semibold text-black">
                                        {__('Custom VC Row Class', 'ultimate_vc')}
                                    </div>
                                    <p style={{ maxWidth: '450px', color: "#9CA3AF" }} className="text-sm">
                                        {__('This option lets you add a custom CSS class to a Visual Composer row for advanced styling and customization.', 'ultimate_vc')}
                                    </p>
                                </div>
                                <input
                                    type="text"
                                    placeholder={__('Enter Class', 'ultimate_vc')}
                                    value={settings.custom_vc_row}
                                    onChange={(e) => setSettings({ ...settings, custom_vc_row: e.target.value })}
                                    style={{
                                        borderColor: '#e0e0e0', // Default border color
                                        outline: 'none',       // Removes the default outline
                                        boxShadow: 'none',     // Removes the default box shadow
                                        marginTop: '8px'
                                    }}
                                    className="w-[240px] px-3 py-2 border border-gray-300 rounded-md text-sm text-gray-800 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                />
                            </div>
                            <hr className="w-full border-b-0 border-x-0 border-t border-solid border-t-border-subtle" style={{ marginTop: '34px', marginBottom: '34px', borderColor: '#E5E7EB' }} />
                        </div>
                    )}


                    {renderToggleRow(__('Developer Mode', 'ultimate_vc'), settings.dev_mode, () => toggle('dev_mode'),
                        __('Shows debug messages and logs for development purposes.', 'ultimate_vc'))}

                    {renderToggleRow(__('Load Scripts Globally', 'ultimate_vc'), settings.global_scripts, () => toggle('global_scripts'),
                        __('Ensures scripts are loaded across all pages instead of conditional loading.', 'ultimate_vc'))}

                    {renderToggleRow(__('Modal on Menu', 'ultimate_vc'), settings.modal_menu, () => toggle('modal_menu'),
                        __('Activates modal behavior for menu items.', 'ultimate_vc'))}

                    {renderToggleRow(__('Smooth Scroll - Old library', 'ultimate_vc'), settings.smooth_scroll_compatible, () => toggle('smooth_scroll_compatible'),
                        __('Fallback compatibility for legacy smooth scroll libraries.', 'ultimate_vc'))}

                    {renderToggleRow(__('Animation Block on Mobile', 'ultimate_vc'), settings.animation_block, () => toggle('animation_block'),
                        __('Disables animations on mobile devices to improve performance.', 'ultimate_vc'))}

                    <div className="flex flex-col">
                        <Title
                            // description={__('Select user roles that can access debug options. Admins are always enabled', 'ultimate_vc')}
                            icon={null}
                            iconPosition="right"
                            size="xs"
                            tag="h2"
                            title={__('Enable Access', 'ultimate_vc')}
                        />
                        <div style={{ marginTop: '15px'}} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-2 gap-x-4">
                            {rolesList.map((role) => (
                                <label
                                    key={role.name}
                                    className="flex items-center space-x-2 text-base text-black font-medium"
                                >
                                    <input
                                        type="checkbox"
                                        className="role-checkbox uavc-remove-ring"
                                        checked={settings.roles.includes(role.name) || role.name === 'administrator'}
                                        disabled={role.name === 'administrator'}
                                        onChange={() => handleRoleChange(role.name)}
                                    />
                                    <span className='text-sm'>{role.label}</span>
                                </label>
                            ))}
                        </div>
                    </div>
                    <Button
                        type="submit"
                        style={{ backgroundColor: '#0017E1', marginTop: '44px' }}
                        iconPosition="left"
                        className="w-full sticky uavc-remove-ring"
                        onClick={handleSave}
                    >
                        {__('Save Changes', 'ultimate_vc')}
                    </Button>
                </div>
            </div>
            )}
        </>
    );
};

export default Debug;
